function Failure(){
    return<>
    <div>Success</div></>
}

export default Failure;